function BlankLoader() {
  return (
    <div className='loader'>
        <div className="dot-loader">
          <span></span><span></span><span></span><span></span>
        </div>
        <p>Loading...</p>
    </div>
  )
}

export default BlankLoader
